// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__1HwOW","question":"Question_question__2kWGF","description":"Question_description__39TMd"};